<app-disclaimer-component></app-disclaimer-component>
<div id="merchant" *ngIf="ready">
  <div class="block w-full mx-auto mb-0 mt-5 max-w-app-max-width min-h-full">
    <component-menu class="mobile-menu-wrapper flex mb-4 tablet:hidden"></component-menu>
    <div class="flex flex-row">
      <!-- Static sidebar for desktop -->
      <div class="hidden tablet:flex tablet:w-72 tablet:flex-col px-0 custom-sidebar-paddings">
        <!-- Sidebar component, swap this element with another sidebar if you like -->
        <div class="flex grow flex-col gap-y-5 overflow-y-auto px-1 menu-sticky">

          <nav class="flex flex-1 flex-col">
            <desktop-fixed-menu></desktop-fixed-menu>
          </nav>
        </div>
      </div>

      <main class="pb-10 w-full">
        <div class="px-2 sm:px-2 lg:pr-0 lg:pl-custom-18">
          <router-outlet></router-outlet>
        </div>
      </main>
    </div>
  </div>
</div>
<app-footer-component></app-footer-component>
